﻿export interface ChatAdd {
    isSuccess: boolean;
    message: string;
    data: any;
    statusCode: string;
    jwtToken: any;
    //totalCount: any;
    errorLog: any;
    chatList?: [{
        userId: number,
        date_Time: Date,
        username: string,
        time: string,
        message: string,
        isShowAll: false
    }]
}
interface ChatDataModel {
    userId: number,
    date_Time: Date,
    username: string,
    time: string,
    message: string,
    isShowAll: false
}

let data2: ChatAdd;
let ChatGet: ChatAdd;


let chatList: { time: string | null; message: string | null; username: string | null; userId: number | null; date_time: Date | null; isShowAll: boolean | false }[] = [];


chatList.push({ time: "", message: "", username: "", userId: 0, date_time: null, isShowAll:false });
 
chatList = [];

export async function chatAdd(code: string | null) {
    //debugger;
    let dBody = {
        code: code,
        chatList: chatList
    };
    dBody = {
        code: code,
        chatList: chatList
    };

    //console.log("COGBEE :: dBody");
    //console.log(dBody);
  
   
    const getData =
        await fetch(window.answerAPI + `v1/Chat/Add`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            //Body: JSON.stringify({ "code": code, chatList })
            body: JSON.stringify(dBody)
        }).then(function (response) {
            //console.log(response)
            return response.json();
        }).then(function (myJson) {
         //   console.log(myJson);

            data2 = myJson as ChatAdd;
            //console.log(data2.message);

        });

    await getData;
 
}

export function Addchatlist(time: string | null, message: string | null, username: string | null, userid: number | null, Datetime: Date | null, isShowAll: boolean | false) {
    const getChatData = GetChatList() as ChatDataModel[];
    if (getChatData.length > 0 && chatList.length <= 0) {
        getChatData.map(item => {
            chatList.push({ time: item.time, message: item.message, username: item.username, userId: item.userId, date_time: item.date_Time, isShowAll: item.isShowAll });
        })
    }
    chatList.push({ time: time, message: message, username: username, userId: userid, date_time: Datetime, isShowAll: isShowAll });
}


export async function getChats(code: string | null) {
    //debugger;
    //const [data, setData] = useState<ChatAdd>();

    const dBody = {
        code: code
    };

    //console.log("COGBEE :: dBody");
    //console.log(dBody);

 
    const getData =
        await fetch(window.answerAPI + `v1/Chat/Get/List`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            //Body: JSON.stringify({ "code": code, chatList })
            body: JSON.stringify(dBody)
        }).then(function (response) {
            
            return response.json();
        }).then(function (myJson) {

            ChatGet = myJson as ChatAdd ;
            
            //console.log(ChatGet)
            //console.log(data2.data)
            ////setData(data2);
            //data2 = data2.data as ;
            //console.log(data2.chatList);

        });

    await getData;
}

const AddChatComplate = () => {
    return {
        chatList
    }
};


const GetChatList = () => {
    if (ChatGet != undefined && ChatGet.chatList!=undefined) {

        return ChatGet.chatList;
    }
    else {

        let nChat: ChatAdd;
        //nChat.chatList = null;
        return {
            userId: 0,
            date_Time: "",
            username: "",
            time: "",
            message: "",
            isShowAll: false
        };
    }
}


const ChatAddModel = () => {
    return {
        Umessage: data2.message
    }
};



export { ChatAddModel, AddChatComplate, GetChatList }